import * as React from 'react';
import Card from "../Card/Card";
import styles from "./SubscriberProfileInfo.module.scss";
import { useState } from "react";
import TextField from '@mui/material/TextField';
import { Box, Button, Grid } from "@mui/material";
import { useForm, Controller } from 'react-hook-form'
import MenuItem from '@mui/material/MenuItem';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import SendRequest from "../../request/SendRequest";
import Dialog from '@mui/material/Dialog';
import { CloseButton } from "react-bootstrap";
import Typography from '@mui/material/Typography';
import alertIcon from '../../assets/alert-icon.svg'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useTranslation } from "react-i18next";

const SubscriberProfileInfo = ({
    userInfoData,
    availableAreaSubdistrictsData,
    noEmailInProfile,
    editProfile,
    setEditProfile,
    setSnackBar,
}) => {
    const { t } = useTranslation();
    const [availableAreaSubdistrictsOptions, setAvailableAreaSubdistrictsOptions] = useState(availableAreaSubdistrictsData.subdistricts[userInfoData.addressInfo.area])

    const [loading, setLoading] = useState(false)
    const [comfirmDialogOpen, setComfirmDialogOpen] = useState(false)
    const handleClose = () => {
        setComfirmDialogOpen(false)
    }

    const {
        register,
        setError,
        getValues,
        setValue,
        reset,
        handleSubmit,
        watch,
        control,
        formState: { errors },
    } = useForm({
        defaultValues: userInfoData
    })
    const addressLine1 = watch([
            "addressInfo.area",
            "addressInfo.secDistrict",
            "addressInfo.street",
            "addressInfo.court"
        ])
        .filter((value) => value && value !== '不適用')
        .join("");
    const addressLine2 = watch([
            "addressInfo.building",
            "addressInfo.block",
            "addressInfo.level",
            "addressInfo.flat"
        ])
        .map((value, index) => {
            if (index === 1 && value) {
                return value + "座";
            }
            if (index === 2 && value) {
                return value + "樓";
            }
            if (index === 3 && value) {
                return value + "室";
            }
            return value;
        })
        .filter((value) => value && value !== '不適用')
        .join("");
    const onSubmit = (data, e) => {
        setLoading(true)
        let submitData = {
            ...data,
            mobilePhone: parseInt(data.mobilePhone, 10),
        };

        SendRequest.post({ url: process.env.REACT_APP_API_URL + 'subscriber/userInfo', data: submitData }).then(response => {
            if (response.status === 200) {
                setEditProfile(!editProfile)
                setSnackBar({
                    open: true,
                    message: response.data.data.message ?? t("submit_success"),
                    severity: "success",
                })
            }
        }).catch(err => {
            if (err.response?.status === 422) {
                Object.keys(err.response?.data?.errors).map((key) => {
                    setError(key, { message: err.response?.data?.errors[key] })
                })
                if (Object.keys(err.response?.data?.errors).length > 0) {
                    setTimeout(() => {
                        const firstErrorField = Object.keys(err.response?.data?.errors)[0];
                        const input = document.querySelector(
                            `form[name="subscriber-profile-info-form"] input[name="${firstErrorField.replace(/\./g, '\\.')}"]`
                        );
                        if (input) {
                            input.scrollIntoView({
                                behavior: 'smooth',
                                block: 'center',
                            });
                        }
                    }, 30000)
                }
            }
            else if (err.response?.status === 400) {
                setSnackBar({
                    open: true,
                    message: err.response?.data?.message ?? t("submit_fail"),
                    severity: "error",
                })
            } else {
                setSnackBar({
                    open: true,
                    message: t("system_busy"),
                    severity: "error",
                })
            }
        }).finally(() => {
            setLoading(false)
            handleClose()
        })
    }
    const getEnabledPromotionOptions = () => {
        let enabledOptions = []
        if (getValues('promotionInfo').sms) {
            enabledOptions.push('SMS')
        }
        if (getValues('promotionInfo').email) {
            enabledOptions.push('電郵')
        }
        if (getValues('promotionInfo').mail) {
            enabledOptions.push('郵件')
        }
        return enabledOptions
    }

    return (
        <>
            <Backdrop
                sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1301 })}
                open={loading}
                invisible
            >
                <CircularProgress style={{'color': '#495057'}} />
            </Backdrop>
            <div className={`subscriber-profile-info ${styles["subscriber-profile-info"]}`}>
                <h2 className={styles["h2"]}>訂戶資料</h2>
                <Card fullWidth={true}>
                    <form name="subscriber-profile-info-form" className={styles["subscriber-profile-info-form"]} onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={2} justifyContent="center" alignItems="center">
                            {
                                noEmailInProfile &&
                                <Grid xs={12} item>
                                    <Box width={"100%"} display={"flex"} flexDirection={"row"} borderRadius={"12px"} bgcolor={"#fff6f3"}>
                                        <Box width={"28px"} height={"28px"} padding={"4px 4px"} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                            <img src={alertIcon} style={{ width: '16px' }} />
                                        </Box>
                                        <Box width={"100%"} padding={"4px 0px"} alignContent={'center'} fontSize={"12px"} fontWeight={500} color={"#FF395D"} textAlign={"left"}>
                                            尚未登記電郵地址
                                        </Box>
                                    </Box>
                                </Grid>
                            }
                            <Grid item xs={12}>
                                <Controller
                                    name="mobilePhone"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateMobilePhone) }}
                                            fullWidth
                                            variant="filled"
                                            label="電話號碼"
                                            error={!!errors.mobilePhone}
                                            helperText={errors.mobilePhone ? errors.mobilePhone.message : ""}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <h3 className={styles["h3"]}>住址</h3>
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="addressInfo.area"
                                    control={control}
                                    rules={{ required: "required" }}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            {...field}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setAvailableAreaSubdistrictsOptions(availableAreaSubdistrictsData.subdistricts[e.target.value]);
                                                setValue("addressInfo.secDistrict", availableAreaSubdistrictsData.subdistricts[e.target.value][0])
                                            }}
                                            label="地區"
                                            error={!!errors.addressInfo?.area}
                                            helperText={errors.addressInfo?.area ? errors.addressInfo?.area.message : ""}
                                            className={`${(editProfile && userInfoData.canUpdateAddressInfo) ? "" : "readonly"}`}
                                            variant="filled"
                                        >
                                            {
                                                availableAreaSubdistrictsData.areas.map((option, index) => {
                                                    return (
                                                        <MenuItem key={index} value={option}>
                                                            {option}
                                                        </MenuItem>
                                                    )
                                                })
                                            }
                                        </TextField>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="addressInfo.secDistrict"
                                    control={control}
                                    rules={{ required: "required" }}
                                    render={({ field }) => (
                                        <TextField
                                            select
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            {...field}
                                            label="分區"
                                            error={!!errors.addressInfo?.secDistrict}
                                            helperText={errors.addressInfo?.secDistrict ? errors.addressInfo?.secDistrict.message : ""}
                                            variant="filled"
                                            className={`${(editProfile && userInfoData.canUpdateAddressInfo) ? "" : "readonly"}`}
                                        >
                                            {
                                                availableAreaSubdistrictsOptions.map((option, index) => {
                                                    return (
                                                        <MenuItem key={index} value={option}>
                                                            {option}
                                                        </MenuItem>
                                                    )
                                                })
                                            }
                                        </TextField>
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="addressInfo.street"
                                    control={control}
                                    render={({ field }) => {
                                        return(
                                            <TextField
                                                {...field}
                                                inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                                fullWidth
                                                label="街道及號數"
                                                error={!!errors.addressInfo?.street}
                                                helperText={errors.addressInfo?.street ? errors.addressInfo?.street.message : ""}
                                                variant="filled"
                                            />
                                        )
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="addressInfo.court"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            label="屋村/屋苑"
                                            error={!!errors.addressInfo?.court}
                                            helperText={errors.addressInfo?.court ? errors.addressInfo?.court.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="addressInfo.building"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            label="大廈"
                                            error={!!errors.addressInfo?.building}
                                            helperText={errors.addressInfo?.building ? errors.addressInfo?.building.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="addressInfo.block"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            label="座數"
                                            error={!!errors.addressInfo?.block}
                                            helperText={errors.addressInfo?.block ? errors.addressInfo.block?.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="addressInfo.level"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            label="樓層"
                                            error={!!errors.addressInfo?.level}
                                            helperText={errors.addressInfo?.level ? errors.addressInfo.level?.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <Controller
                                    name="addressInfo.flat"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: (!editProfile || !userInfoData.canUpdateAddressInfo) }}
                                            fullWidth
                                            label="室/單位"
                                            error={!!errors.addressInfo?.flat}
                                            helperText={errors.addressInfo?.flat ? errors.addressInfo.flat?.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="addressInfo.addressLine1"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: true }}
                                            fullWidth
                                            label="地址行1"
                                            error={!!errors.addressInfo?.addressLine1}
                                            helperText={errors.addressInfo?.addressLine1 ? errors.addressInfo.addressLine1?.message : ""}
                                            variant="filled"
                                            value={addressLine1}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="addressInfo.addressLine2"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: true }}
                                            fullWidth
                                            label="地址行2"
                                            error={!!errors.addressInfo?.addressLine2}
                                            helperText={errors.addressInfo?.addressLine2 ? errors.addressInfo.addressLine2?.message : ""}
                                            variant="filled"
                                            value={addressLine2}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Controller
                                    name="emailAddress"
                                    control={control}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            inputProps={{ readOnly: !editProfile }}
                                            fullWidth
                                            label="電郵地址"
                                            error={!!errors.emailAddress}
                                            helperText={errors.emailAddress ? errors.emailAddress.message : ""}
                                            variant="filled"
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div className={`${styles["checkbox-group"]} ${editProfile ? "" : styles["readonly"]}`}>
                                    <label>推廣設定</label>
                                    <div className={styles["checkbox-group-div"]}>
                                        <FormGroup>
                                            <FormControlLabel
                                                //  className="formcontrollabel-testing"
                                                style={editProfile ? {} : { pointerEvents: "none" }}
                                                control={
                                                    <Controller
                                                        name={"promotionInfo.sms"}
                                                        control={control}
                                                        render={({ field: props }) => (
                                                            <Checkbox
                                                                disabled={!editProfile}
                                                                {...props}
                                                                checked={props.value}
                                                                onChange={(e) => props.onChange(e.target.checked)}
                                                            />
                                                        )}
                                                    />
                                                }
                                                label={"SMS"}
                                            />


                                            <FormControlLabel
                                                style={editProfile ? {} : { pointerEvents: "none" }}
                                                control={
                                                    <Controller
                                                        name={"promotionInfo.email"}
                                                        control={control}
                                                        render={({ field: props }) => (
                                                            <Checkbox
                                                                disabled={!editProfile}
                                                                {...props}
                                                                checked={props.value}
                                                                onChange={(e) => props.onChange(e.target.checked)}
                                                            />
                                                        )}
                                                    />
                                                }
                                                label={"電郵"}
                                            />
                                            <FormControlLabel
                                                style={editProfile ? {} : { pointerEvents: "none" }}
                                                control={
                                                    <Controller
                                                        name={"promotionInfo.mail"}
                                                        control={control}
                                                        render={({ field: props }) => (
                                                            <Checkbox
                                                                disabled={!editProfile}
                                                                {...props}
                                                                checked={props.value}
                                                                onChange={(e) => props.onChange(e.target.checked)}
                                                            />
                                                        )}
                                                    />
                                                }
                                                label={"郵件"}
                                            />

                                        </FormGroup>
                                    </div>
                                </div>
                            </Grid>
                            <Grid item xs={12} className={styles["remark"]}>
                                <p className={styles["p"]}>
                                    您選取了的推廣設定選項，代表您同意接收來自長者安居協會的推廣訊息，包括一線通®平安鐘及一線通管家易®服務的最新消息及推廣訊息、募捐及其他活動資訊、優惠以及更新資訊等。
                                </p>
                                <p className={styles["p"]}>
                                    推廣設定並不會影響我們向您發出有關平安服務的緊急通訊。
                                </p>
                            </Grid>
                            <Grid item xs={12} gap={2} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                {
                                    editProfile ?
                                        <>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); setEditProfile(false); reset(); }}
                                            >
                                                取消
                                            </Button>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); setComfirmDialogOpen(true); }}
                                            >
                                                {loading ? "儲存中" : "儲存"}
                                            </Button>
                                        </>
                                        :
                                        <>
                                            <Button
                                                type="button"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                onClick={(e) => { e.preventDefault(); setEditProfile(true); }}
                                            >
                                                編輯
                                            </Button>
                                        </>
                                }
                                <Dialog
                                    open={comfirmDialogOpen}
                                    onClose={handleClose}
                                    disablePortal
                                    maxWidth="md"
                                    PaperProps={{style:{margin:0,borderRadius:"10px"}}}
                                    sx={{ borderRadius: "40px", width: "100%" }}
                                >
                                    <div className={styles["confirm-dialog"]}>
                                        <div className={styles["dialog-close-div"]}>
                                            <CloseButton style={{ marginLeft: "auto" }} onClick={handleClose}></CloseButton>
                                        </div>

                                        <div className={styles["dialog-content"]}>
                                            {/* <div className={styles["dialog-title"]}>
                                            <h1>確認以下訂戶資料</h1>
                                        </div> */}
                                            <div className={styles["info-row"]}>
                                                <h1>確認以下訂戶資料</h1>
                                            </div>
                                            <div className={styles["info-row"]}>
                                                <div className={styles["info-type"]}>電話號碼</div>
                                                <div className={styles["info-value"]}>{getValues("mobilePhone")}</div>
                                            </div>
                                            <div className={styles["info-row"]}>

                                                <div className={styles["info-type"]}>住址</div>
                                                <div className={styles["info-value"]}>{addressLine1}{addressLine2}</div>
                                            </div>
                                            <div className={styles["info-row"]}>

                                                <div className={styles["info-type"]}>電郵地址</div>
                                                <div className={styles["info-value"]}>{getValues("emailAddress")}</div>
                                            </div>
                                            <div className={styles["info-row"]}>
                                                <div className={styles["info-type"]}>推廣設定</div>
                                                <div className={styles["info-value"]}>
                                                    {getEnabledPromotionOptions().join(", ")}
                                                </div>

                                            </div>
                                        </div>
                                        <div className={styles["dialog-actions"]}>
                                            <Button onClick={handleClose}>取消</Button>
                                            <Button
                                                type="submit"
                                                variant="outlined"
                                                color="primary"
                                                size="medium"
                                                disabled={loading}
                                            >
                                                儲存
                                            </Button>
                                        </div>
                                    </div>
                                </Dialog>
                            </Grid>
                        </Grid>
                    </form>
                </Card>
            </div>
        </>
    );
};

export default SubscriberProfileInfo;